import React from 'react';
import settingsParams from '../../../settingsParams';
import s from './Headline.scss';
import {HTMLTag} from '../HTMLTag/HTMLTag';
import {ContinueShopping, ContinueShoppingPosition} from '../ContinueShopping/ContinueShopping';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {Caret} from '../Icons/Caret';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';

export enum HeadlineDataHook {
  root = 'HeadlineDataHook.root',
}

const RenderContinueShopping = () => {
  return (
    <div className={s.continueShopping}>
      <ContinueShopping position={ContinueShoppingPosition.headline} />
      <Caret className={s.caret} />
    </div>
  );
};

const RenderTitle = ({title}: {title: string}) => {
  return (
    <HTMLTag type="h1" className={s.title} data-hook={HeadlineDataHook.root}>
      {title}
    </HTMLTag>
  );
};

export function Headline() {
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const {shouldRenderEmptyState} = useControllerProps()?.cartStore || {};
  const {shouldRenderContinueShopping} = useControllerProps()?.navigationStore || {};
  const withContinueShopping = shouldRenderContinueShopping && !shouldRenderEmptyState;

  return (
    <div className={s.headline}>
      <RenderTitle title={getSettingsWithDefaults(settingsParams.CART_TITLE)} />

      {withContinueShopping && <RenderContinueShopping />}
    </div>
  );
}
